document.addEventListener('DOMContentLoaded', function() {
  // すべての価格要素を取得
  const priceElements = document.querySelectorAll('.price-item');
  
  priceElements.forEach(function(element) {
    const priceText = element.textContent.trim();
    
    // ¥0 または ¥0.00 の場合に「営業相談」に置き換え
    if (priceText === '¥0' || priceText === '¥0.00' || priceText === '¥0円') {
      element.textContent = '営業相談';
    }
  });
});
